module.exports = __webpack_public_path__ + "img/wolf-infected.9be0d228.png";